import { render, staticRenderFns } from "./Harjoitussuunnitelma.vue?vue&type=template&id=36195b92&scoped=true"
import script from "./Harjoitussuunnitelma.vue?vue&type=script&lang=js"
export * from "./Harjoitussuunnitelma.vue?vue&type=script&lang=js"
import style0 from "./Harjoitussuunnitelma.vue?vue&type=style&index=0&id=36195b92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36195b92",
  null
  
)

export default component.exports